import { FormStepValue, FormValues } from 'src/app/shared/models/evolutionForm';

const isYes = (value: any) => value === 'Sí' || value === 'Si';

// Free text is escaped because evolutions are rendered with innerHTML.
const escapeHtml = (text: string) =>
    String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const extractValue = (value: any): string => {
    if (Array.isArray(value)) return value.map(extractValue).join(', ');
    if (value !== null && typeof value === 'object') return value.label ?? value.value;
    if (typeof value === 'boolean') return value ? 'Sí' : 'No';
    return value;
};

export function formToEvolution(values: FormValues): { description: string; evolutionType: number } {
    let evolutionType = 1;
    const byStep = new Map<number, { title: string; items: FormStepValue[] }>();

    Object.values(values).forEach(item => {
        const stepNumber = item.step?.number ?? 0;
        if (!byStep.has(stepNumber)) byStep.set(stepNumber, { title: item.step?.title ?? '', items: [] });
        byStep.get(stepNumber).items.push(item);
    });

    const lines: string[] = [];
    [...byStep.keys()].sort((a, b) => a - b).forEach(stepNumber => {
        const { title, items } = byStep.get(stepNumber);
        lines.push(`<b>${escapeHtml(title)}</b>`);

        items.forEach(item => {
            lines.push(`${escapeHtml(item.title)}: ${escapeHtml(extractValue(item.value))}`);

            const firstChar = item.title?.charAt(0);
            if (item.title === 'Informar al financiador' || firstChar === '+') {
                if (evolutionType < 4) {
                    if (isYes(item.value)) evolutionType = 4;
                    else if (item.value === 'No') evolutionType = 1;
                }
            } else if (item.title === 'Es paciente en condición de alta?' || firstChar === '|') {
                if (isYes(item.value)) evolutionType = 10;
                else if (item.value === 'No') evolutionType = 1;
            }
        });
    });

    return { description: lines.join('\n'), evolutionType };
}
